const init = (page_name) => {
    let isAccess = false;
    const user_access_arr = window.localStorage.getItem('UserAccess');
    if (user_access_arr?.includes(page_name)) {
        isAccess = true;
    }
    
    return isAccess;
}

export default init;